import { InputOutlined } from '@material-ui/icons'
import MaterialTags from 'components/Common/ArticleSelector/MaterialTags'
import { saveBomItemMaterials } from 'features/BillOfMaterials/store/asyncActions/saveBomItemMaterials'
import { bomItemMaterialSummarySelector } from 'features/BillOfMaterials/store/selectors/bomItemMaterialSummarySelector'
import { isEqual, merge } from 'lodash'
import { useAppSelector } from 'store/configureStore'
import { materialClipboardSelector } from 'store/MaterialSelector/MaterialSelectors'
import { BomItemMenuItem } from './BomItemMenuItem'

export const PasteMaterialMenuItem = ({
  bomItemId,
  onClose,
}: {
  bomItemId: string
  onClose: () => void
}) => {
  const materialClipboard = useAppSelector(materialClipboardSelector, isEqual)
  const bomItemMaterialSummary = useAppSelector(
    bomItemMaterialSummarySelector(bomItemId),
    isEqual
  )

  if (!materialClipboard) {
    return null
  }

  return (
    <BomItemMenuItem
      disableIfNotEditable
      action={saveBomItemMaterials}
      actionParams={{
        bomItemId,
        material: {
          tokens: merge(
            {},
            bomItemMaterialSummary.tokens,
            materialClipboard.tokens
          ),
        },
      }}
      icon={<InputOutlined />}
      primaryTextTranslationKey="project:paste-material"
      secondary={<MaterialTags selectedTokens={materialClipboard.tokens} />}
      closeAfterFullfilled
      onClose={onClose}
    />
  )
}
